import { Box, Chip, Stack, Typography } from "@mui/material";
import { PDFDownloadLink } from "@react-pdf/renderer";
import axios from "axios";
import dayjs from "dayjs";
import moment from "moment";
import { useContext, useEffect, useMemo, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import DuplicateCountDialog from "../../../components/dialogs/DuplicateCountDialog";
import DynamicTable from "../../../components/dynamicTable";
import AppLoader from "../../../components/loader";
import ContractSummaryPDF from "../../../components/preContractPdf";
import { AppContext } from "../../../lib/Context";
import { emailRegex, getDefaultContractLengths } from "../../../lib/Variable";
import { baseUrl } from "../../../services";
import {
  getContractDetails,
  updateContract,
} from "../../../services/ContractApi";
import {
  compareTopLevelKeys,
  dateChangesLog,
  debitDetailsChangesLog,
  debitDetailsValueChangesLog,
  ebillingChangesLog,
  followUpAndEndDateChangesLog,
  getCordedChangesLog,
  getCordedlessChangesLog,
  getDownlaodSpeedChangesLog,
  getEquipmentChangesLog,
  getGeneralInfoChangesLog,
  getRouterChangesLog,
  getUploadSpeedChangesLog,
  upfrontPaymentChangesLog,
} from "../../../utils/LoggingFn";
import {
  areAllKeysFilled,
  checkSpeedAvailability,
  handleOpenSnackBar,
  hasErrorInLineValues,
  selectedContractLength,
  validateOtherProductFields,
} from "../../../utils/helper";
import GlobalButton from "./../../../components/button/index";
import AppHeader from "./../../../components/header/index";
import Cli from "./Cli";
import ContractLength from "./ContractLength";
import CordedPhone from "./CordedPhone";
import CordedlessPhone from "./CordedlessPhone";
import DebitDetails from "./DebitDetails";
import Download from "./Download";
import Equipments from "./Equipments";
import GeneralConnections from "./GeneralConnections";
import Logs from "./Logs";
import Note from "./Note";
import OtherProducts from "./OtherProducts";
import PaperBillingCharges from "./PaperBillingCharges";
import Routers from "./Routers";
import SameConnections from "./SameConnections";
import Upload from "./Upload";
import { useDispatch, useSelector } from "react-redux";
import { setPhoneValidation } from "../../../lib/redux/slices/phoneValidationSlice";
import { setSignedDate } from "../../../lib/redux/slices/signedDateSlice";
import SignedDate from "./SignedDate";
import { getAdminAgentDetails } from "../../../services/AgentApi";
import {
  setDiscount,
  setDiscountDetails,
} from "../../../lib/redux/slices/discountSlice";
import Discount from "./Discount";
import UpdateAgentDialog from "../../../components/dialogs/UpdateAgentDialog";
import { getAccessToken } from "../../../services/tokenStore";

const tableHeader = [
  "Prospect Details",
  "Connect Details",
  "Sale Value",
  "Docusign Status",
  "Sale Status",
  "Edit",
];

const displayRows = [
  "customer_details",
  "connectDetails",
  "paymentDetails",
  "contract_status",
  "saleStatus",
  "actions",
];

const EditConnectionsPage = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const [linkedContract, setLinkedContract] = useState([]);
  const openDublicateDialogRef = useRef(null);
  const openUpdateAgentDialogRef = useRef(null);
  const [isLoading, setIsLoading] = useState(false);
  const [adminDetails, setAdminDetail] = useState(null);

  const {
    // Just Note

    note,
    setNote,
    // Account No
    accountNo,
    setAccountNo,

    // General Information
    generalInfo,
    setGeneralInfo,
    isBillingEmailSame,
    setIsBillingEmailSame,

    // Contract Length
    contractLength,
    setContractLength,
    setShowAllContractLengths,

    // Cli Data
    cliData,
    setCliData,

    // Download Speed
    downloadSpeed,
    setDownloadSpeed,

    // Upload Speed
    uploadSpeed,
    setUploadSpeed,

    // Router Value
    routerValue,
    setRouterValue,

    // Corded Phone
    cordedPhone,
    setSetCordedPhone,

    // Cordless Phone
    cordedlessPhone,
    setCordlessPhone,

    // Equipments
    equipments,
    setEquipments,

    // Ebilling Address
    eBillingAddress,
    setEbillingAddress,

    // Add direct debit details Option
    isReqDebitDetail,
    setIsReqDebitDetail,

    // Debit Details Information
    debitDetails,
    setDebitDetails,

    // Papper Billing Price
    paperBillingPrice,
    setPaperBillingPrice,

    // All Notes
    allNotes,
    setAllNotes,

    // Upfront Payment collected
    isUpfrontPaymentCollected,
    setIsUpfrontPaymentCollected,

    // Contract End Date
    contractEndDate,
    setContractEndDate,

    // Follow up date
    followUpDate,
    setFollowUpDate,

    // Summary send
    setIsSummarySend,

    // Other Products
    otherProducts,
    setOtherProducts,

    userData,
    handleResetData,

    // Send Type
    setSendType,

    // Bank validation
    isBankDetailsVerified,
    setIsBankDetailsVerified,

    // Revenue and one-off cost calculation
    calculateGrossProfit,
    calculateOneOfCost,
    calculateTotalRevenue,
    calculateOneOfCostProfit,
  } = useContext(AppContext);

  const { isDownloadSpeed, isUploadSpeed } = checkSpeedAvailability(cliData);

  {
    (() => {
      const showOnce = [
        "Care Level 2",
        "Care Level 3",
        "Care Level 4",
        "Static IP",
        "Business Assurance",
      ];

      const allServices = [];

      cliData?.forEach((x, index) => {
        if (!x.additionalService.isSelected) return;

        // Process all line values, not just [0]
        x.lineValues?.forEach((services, lineIndex) => {
          let selectedServices = [];

          if (x.digitalTariff.isSelected) {
            selectedServices = [
              services?.ngnService1,
              services?.ngnService2,
              services?.ngnService3,
              services?.ngnService4,
            ].filter(Boolean);
          } else if (x.legacyTariff.isSelected) {
            selectedServices = [
              services?.legacyService1,
              services?.legacyService2,
              services?.legacyService3,
              services?.legacyService4,
            ].filter(Boolean);
          }

          // Filter duplicates for showOnce services
          const uniqueServices = selectedServices.filter(
            (service, idx, self) => {
              if (!showOnce.includes(service.value)) return true;
              return idx === self.findIndex((s) => s.value === service.value);
            },
          );

          allServices.push(...selectedServices);
        });
      });
    })();
  }

  const [boxData, setBoxData] = useState([]);
  const [contractDetails, setContractDetails] = useState({});
  const { phoneValidation } = useSelector(
    (state) => state.phoneValidationReducer,
  );
  const { signedDate } = useSelector((state) => state.signedDateReducer);
  const { discount, discountDetails } = useSelector(
    (state) => state.discountReducer,
  );

  const isAdmin = userData?.designation === "Admin" ? true : false;
  const totalOneOfCost = calculateOneOfCost();
  const totalRevenue = calculateTotalRevenue();
  const totalGrossProfit =
    parseFloat(calculateGrossProfit()) + parseFloat(calculateOneOfCostProfit());

  /**
   *
   * Merging the cli Data
   * Add migration object in array if not present
   * Add transfer object in array if not present
   */

  const upgradeCharge = {
    title: "Install",
    isSelected: false,
    type: "upgradeCharge",
    salePrice: 60,
    buyPrice: 60,
    attachedValue: "",
    timePeriod: "",
    upPayment: true,
    isCollected: "",
    liveDate: null,
    isImmediate: true,
  };

  const migration = {
    title: "Migration",
    isSelected: false,
    type: "migration",
    salePrice: 60,
    buyPrice: 60,
    attachedValue: "",
    timePeriod: "",
    upPayment: false,
    firstMonth: false,
    isCollected: "",
    liveDate: null,
    isImmediate: true,
  };

  const transfer = {
    title: "Transfer",
    isSelected: false,
    type: "transfer",
    attachedValue: "",
    liveDate: null,
    isImmediate: true,
  };

  const mergeCliData = (existingData) => {
    return existingData.map((existingItem, index) => {
      let updatedItem = { ...existingItem };

      updatedItem.upgradeCharge = {
        ...upgradeCharge,
        ...existingItem?.upgradeCharge,
      };

      if (!existingItem.migration) {
        updatedItem.migration = {
          title: "Migration",
          isSelected: false,
          type: "migration",
          salePrice: 60,
          buyPrice: 60,
          attachedValue: "",
          timePeriod: "",
          upPayment: false,
          firstMonth: false,
          isCollected: "",
          liveDate: null,
          isImmediate: true,
        };
      } else {
        updatedItem.migration = {
          ...migration,
          ...existingItem.migration,
        };
      }

      if (!existingItem.transfer) {
        updatedItem.transfer = {
          title: "Transfer",
          isSelected: false,
          type: "transfer",
          attachedValue: "",
          liveDate: null,
          isImmediate: true,
        };
      } else {
        updatedItem.transfer = {
          ...transfer,
          ...existingItem.transfer,
        };
      }

      return updatedItem;
    });
  };

  useEffect(() => {
    if (location.state) {
      fetchContractsDetails(location?.state?.data?._id);
      fetchAdminDetail(userData?._id);
    }
  }, [location.state]);

  const fetchAdminDetail = async (id) => {
    const fields = "canPreview";
    try {
      const response = await getAdminAgentDetails(id, fields);
      if (response.data.status === "success") {
        const data = response.data.data;
        setAdminDetail(data);
      }
    } catch (error) {}
  };

  const fetchContractsDetails = async (id) => {
    try {
      setIsLoading(true);
      const response = await getContractDetails(id);
      if (response?.data.status === "success") {
        let data = response?.data.data;
        let linked = response?.data.linkedContract;
        setContractDetails(data);
        setLinkedContract(linked);
        setBoxData(structuredClone(data.cliData));

        // General Information Part
        const scname =
          data?.generalInfo?.secondName !== "" &&
          data?.generalInfo?.secondName !== null &&
          data?.generalInfo?.secondName !== undefined;

        const contractLiveDate = data?.generalInfo?.liveDate
          ? dayjs(data?.generalInfo?.liveDate)
          : null;

        const updatedGeneralInfo = {
          ...data.generalInfo,
          signupDate: data?.createdAt,
          isAddCustomer: scname,
          liveDate: contractLiveDate,
        };

        // Set Selected Contract Length

        const selectedContract = getDefaultContractLengths().map((x) => {
          const saved = data?.contractLength;
          let isMatch = false;

          if (saved?.pricingMode != null) {
            isMatch =
              x.pricingMode === saved.pricingMode &&
              x.value === saved.value &&
              (!saved.title || x.title === saved.title);
          } else if (saved?.title) {
            isMatch = x.title === saved.title;
          } else {
            // Older records without pricingMode: do not select buy-mode (Saver) by value alone
            isMatch =
              x.value === saved?.value && x.pricingMode !== "buy";
          }

          return { ...x, isSelected: Boolean(isMatch) };
        });

        // Update Notes

        const updateNotes =
          typeof data?.contractNote === "string"
            ? data.contractNote.trim()
              ? [
                  {
                    createdAt: data?.createdAt,
                    updatedAt: data?.updatedAt,
                    text: data?.contractNote,
                    createdBy: data?.createdBy || "",
                  },
                ]
              : []
            : data?.contractNote;

        // Contract end date

        const updatedContractEndData = data?.contractEndDate
          ? dayjs(data?.contractEndDate)
          : null;

        // Follow up date

        const updatedFollowUpDate = data?.followUpDate
          ? dayjs(data?.followUpDate)
          : null;

        setNote(data?.note || "");
        setAccountNo(data?.accountNo);
        setGeneralInfo(updatedGeneralInfo);
        setIsBillingEmailSame(data?.isBillingEmailSame);
        setContractLength(selectedContract);
        // New contracts save availableForNew: true → keep 3 options on edit.
        // Old contracts (key missing/false) → show all lengths including 12/18.
        setShowAllContractLengths(data?.contractLength?.availableForNew !== true);
        setCliData(mergeCliData(data?.cliData));
        setDownloadSpeed(data?.downloadSpeed);
        setUploadSpeed(data?.uploadSpeed);
        setRouterValue(data?.routerValue);
        setSetCordedPhone(data?.cordedPhone);
        setCordlessPhone(data?.cordedlessPhone);
        setEquipments(data?.equipments);
        setEbillingAddress(data?.eBillingAddress);
        setIsReqDebitDetail({
          yes: data?.isDebitDetails,
          no: !data?.isDebitDetails,
        });

        setDebitDetails(data?.debitDetails);
        setIsBankDetailsVerified(data?.isBankDetailsVerified);
        setPaperBillingPrice(data?.paperBillingPrice);
        setAllNotes(updateNotes);
        setIsUpfrontPaymentCollected(data?.isUpfrontPaymentCollected || "");
        setContractEndDate(updatedContractEndData);
        setFollowUpDate(updatedFollowUpDate);
        setIsSummarySend(true);
        dispatch(setPhoneValidation(data?.phoneDetail));
        dispatch(setSignedDate(dayjs(data?.contractSignedAt)));
        dispatch(setDiscount(data?.discount || null));
        dispatch(setDiscountDetails(data?.discountDetails || null));

        if (data?.otherProduct) {
          const otherProductsData = {
            selectedProducts: [],
            energy: {
              electricity: {
                isSelected: false,
                currentSupplier: "",
                date: "",
                meterNumber: "",
                monthlySpend: "",
                notesSelection: "",
                followUpDate: "",
              },
              gas: {
                isSelected: false,
                currentSupplier: "",
                date: "",
                meterNumber: "",
                monthlySpend: "",
                notesSelection: "",
                followUpDate: "",
              },
            },
            telecoms: {
              business: {
                isSelected: false,
                currentSupplier: "",
                date: "",
                meterNumber: "",
                monthlySpend: "",
                notesSelection: "",
                followUpDate: "",
              },
              residential: {
                isSelected: false,
                currentSupplier: "",
                date: "",
                meterNumber: "",
                monthlySpend: "",
                notesSelection: "",
                followUpDate: "",
              },
            },
            cardProcessing: {
              currentSupplier: "",
              date: "",
              meterNumber: "",
              monthlySpend: "",
              notesSelection: "",
              followUpDate: "",
            },
            mobile: {
              currentSupplier: "",
              date: "",
              meterNumber: "",
              monthlySpend: "",
              notesSelection: "",
              followUpDate: "",
            },
          };

          const products = Array.isArray(data?.otherProduct)
            ? data?.otherProduct
            : [data?.otherProduct];

          products.forEach((product) => {
            otherProductsData.selectedProducts.push(product.productType);

            if (product.productType === "Energy") {
              if (product.data.electricity) {
                otherProductsData.energy.electricity = {
                  ...product.data.electricity,
                  isSelected: true,
                };
              }
              if (product.data.gas) {
                otherProductsData.energy.gas = {
                  ...product.data.gas,
                  isSelected: true,
                };
              }
            } else if (product.productType === "Telecoms") {
              if (product.data.business) {
                otherProductsData.telecoms.business = {
                  ...product.data.business,
                  isSelected: true,
                };
              }
              if (product.data.residential) {
                otherProductsData.telecoms.residential = {
                  ...product.data.residential,
                  isSelected: true,
                };
              }
            } else if (product.productType === "Card Processing") {
              otherProductsData.cardProcessing = {
                ...product.data,
                isSelected: true,
              };
            } else if (product.productType === "Mobile") {
              otherProductsData.mobile = {
                ...product.data,
                isSelected: true,
              };
            }
          });

          setOtherProducts(otherProductsData);
        } else {
          setOtherProducts({
            selectedProducts: [],
            energy: {
              electricity: {
                isSelected: false,
                currentSupplier: "",
                date: "",
                meterNumber: "",
                monthlySpend: "",
                notesSelection: "",
                followUpDate: "",
              },
              gas: {
                isSelected: false,
                currentSupplier: "",
                date: "",
                meterNumber: "",
                monthlySpend: "",
                notesSelection: "",
                followUpDate: "",
              },
            },
            telecoms: {
              business: {
                isSelected: false,
                currentSupplier: "",
                date: "",
                meterNumber: "",
                monthlySpend: "",
                notesSelection: "",
                followUpDate: "",
              },
              residential: {
                isSelected: false,
                currentSupplier: "",
                date: "",
                meterNumber: "",
                monthlySpend: "",
                notesSelection: "",
                followUpDate: "",
              },
            },
            cardProcessing: {
              currentSupplier: "",
              date: "",
              meterNumber: "",
              monthlySpend: "",
              notesSelection: "",
              followUpDate: "",
            },
            mobile: {
              currentSupplier: "",
              date: "",
              meterNumber: "",
              monthlySpend: "",
              notesSelection: "",
              followUpDate: "",
            },
          });
        }
      } else {
        handleOpenSnackBar("error", response?.data.message);
      }
    } catch (error) {
      handleOpenSnackBar("error", error?.message);
    } finally {
      setIsLoading(false);
    }
  };

  const handleUpdateOrPreviewContract = async (type) => {
    // Debit detail pais
    const isDebitDetailsRequired = {
      initial: contractDetails?.isDebitDetails,
    };

    const repliceDebitDetails = {
      initial: isReqDebitDetail?.yes,
    };

    // Contract and and follow update
    const endAndFollowDateInitial = {
      end:
        contractDetails?.contractEndDate === null
          ? null
          : moment(contractDetails?.contractEndDate).format("DD.MM.YY"),
      follow:
        contractDetails?.followUpDate === null
          ? null
          : moment(contractDetails?.followUpDate).format("DD.MM.YY"),
    };

    const endAndFollowDateAfter = {
      end:
        contractEndDate === null
          ? null
          : moment(contractEndDate?.$d).format("DD.MM.YY"),
      follow:
        followUpDate === null
          ? null
          : moment(followUpDate?.$d).format("DD.MM.YY"),
    };

    const allDatesInitial = {
      contractSignedDate:
        contractDetails?.contractSignedAt === null
          ? null
          : moment(contractDetails?.contractSignedAt).format(
              "DD.MM.YY hh:mm a",
            ),
    };

    const allDatesAfter = {
      contractSignedDate:
        signedDate === null
          ? null
          : moment(signedDate?.$d).format("DD.MM.YY hh:mm a"),
    };

    // General Information
    const generalInfoInitial = {
      ...contractDetails?.generalInfo,
      accountNo: contractDetails?.accountNo,
      note: contractDetails?.note || "",
      signupDate:
        contractDetails?.generalInfo?.signupDate === null
          ? null
          : moment(contractDetails?.generalInfo?.signupDate).format("DD.MM.YY"),
      liveDate:
        contractDetails?.generalInfo?.liveDate === null
          ? null
          : moment(contractDetails?.generalInfo?.liveDate).format("DD.MM.YY"),
    };
    const generalInfoAfter = {
      ...generalInfo,
      accountNo,
      note,
      signupDate:
        generalInfo?.signupDate === null
          ? null
          : moment(generalInfo?.signupDate).format("DD.MM.YY"),
      liveDate:
        generalInfo?.liveDate === null
          ? null
          : moment(generalInfo?.liveDate?.$d).format("DD.MM.YY"),
    };

    // Functions to take d/f b/w old and new one
    const generalInfoLog = getGeneralInfoChangesLog(
      generalInfoInitial,
      generalInfoAfter,
      userData?.username,
    );

    const cliBoxLog = compareTopLevelKeys(boxData, cliData, userData?.username);

    const downloadSpeedLog = getDownlaodSpeedChangesLog(
      contractDetails?.downloadSpeed,
      downloadSpeed,
      userData?.username,
    );

    const uploadSpeedSpeedLog = getUploadSpeedChangesLog(
      contractDetails?.uploadSpeed,
      uploadSpeed,
      userData?.username,
    );

    const routerValueLog = getRouterChangesLog(
      contractDetails?.routerValue,
      routerValue,
      userData?.username,
    );

    const cordedPhoneLog = getCordedChangesLog(
      contractDetails?.cordedPhone,
      cordedPhone,
      userData?.username,
    );

    const cordedlessPhoneLog = getCordedlessChangesLog(
      contractDetails?.cordedlessPhone,
      cordedlessPhone,
      userData?.username,
    );

    const equipmentLog = getEquipmentChangesLog(
      contractDetails?.equipments,
      equipments,
      userData?.username,
    );

    const eBillingLog = ebillingChangesLog(
      contractDetails?.eBillingAddress,
      eBillingAddress,
      userData?.username,
    );

    const debitLog = debitDetailsChangesLog(
      isDebitDetailsRequired,
      repliceDebitDetails,
      userData?.username,
    );

    const debitAccountValueLog = debitDetailsValueChangesLog(
      contractDetails?.debitDetails,
      debitDetails,
      userData?.username,
    );

    const upfrontPaymentLog = upfrontPaymentChangesLog(
      { isUpfrontPaymentCollected: contractDetails?.isUpfrontPaymentCollected },
      { isUpfrontPaymentCollected },
      userData?.username,
    );

    const contractEndAndFollowUpDateLog = followUpAndEndDateChangesLog(
      endAndFollowDateInitial,
      endAndFollowDateAfter,
      userData?.username,
    );

    const contractSignedDateLog = dateChangesLog(
      allDatesInitial,
      allDatesAfter,
      userData?.username,
    );

    const logArray = [
      ...generalInfoLog,
      ...cliBoxLog,
      ...downloadSpeedLog,
      ...uploadSpeedSpeedLog,
      ...routerValueLog,
      ...cordedPhoneLog,
      ...cordedlessPhoneLog,
      ...equipmentLog,
      ...eBillingLog,
      ...debitLog,
      ...debitAccountValueLog,
      ...upfrontPaymentLog,
      ...contractEndAndFollowUpDateLog,
      ...contractSignedDateLog,
    ];

    const isAllGenInfoFilled = areAllKeysFilled(generalInfo, [
      "signupDate",
      "eBilling",
      "address2",
      "town",
      "secondName",
      "isAddCustomer",
      "liveDate",
    ]);

    if (!isAllGenInfoFilled.allFilled) {
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
      return handleOpenSnackBar(
        "error",
        `${isAllGenInfoFilled.emptyFields} fields are required`,
      );
    }

    if (generalInfo.email && !emailRegex.test(generalInfo.email)) {
      return handleOpenSnackBar("error", "Invalid customer email format");
    }

    if (!isBillingEmailSame && !emailRegex.test(generalInfo.billingEmail)) {
      return handleOpenSnackBar("error", "Invalid billing email format");
    }

    if (generalInfo?.isAddCustomer && generalInfo?.secondName?.trim() === "") {
      return handleOpenSnackBar("error", "Add Customer field is required");
    }

    const isContractSeclected = contractLength.find(
      (item) => item.isSelected === true,
    );

    if (isContractSeclected === undefined) {
      return handleOpenSnackBar("error", "Kindly select contract length first");
    }

    if (
      hasErrorInLineValues(cliData) &&
      !adminDetails?.canPreview
      // !isAdmin
      // contractDetails?.createdBy === "Sales Agent"
    ) {
      return handleOpenSnackBar(
        "error",
        "Error in connection box. Please resolve.",
      );
    }

    const isAllowedToProceed = cliData.every((item) => {
      if (item?.digitalTariff?.isSelected) {
        return (
          item.transfer.isSelected ||
          item.migration.isSelected ||
          item.upgradeCharge.isSelected
        );
      }
      return true;
    });

    if (!isAllowedToProceed) {
      return handleOpenSnackBar(
        "error",
        "Kindly select at least one option (Install, Migration and Transfer) for Digital/NGN",
      );
    }

    if (isNaN(routerValue.price)) {
      return handleOpenSnackBar("error", "Router price can not be empty");
    }

    if (isNaN(cordedPhone.price)) {
      return handleOpenSnackBar("error", "Corded phone price can not be empty");
    }

    if (isNaN(cordedlessPhone.price)) {
      return handleOpenSnackBar(
        "error",
        "Cordless phone price can not be empty",
      );
    }

    if (!equipments.value?.trim() && isNaN(equipments.price)) {
      return handleOpenSnackBar(
        "error",
        "Kindly Select or write value For Equipments",
      );
    }

    if (equipments.value?.trim() && isNaN(equipments.price)) {
      return handleOpenSnackBar("error", "Equipment price can not be empty");
    }

    if (generalInfo.eBilling == "") {
      return handleOpenSnackBar(
        "error",
        "Kindly select option for paper billing Charges",
      );
    }

    if (generalInfo.eBilling == "No" && paperBillingPrice.error) {
      return handleOpenSnackBar(
        "error",
        "Kindly resolve error on paper billing charges",
      );
    }

    const paperBillingField = areAllKeysFilled(eBillingAddress);

    if (generalInfo.eBilling == "No" && !paperBillingField.allFilled) {
      return handleOpenSnackBar(
        "error",
        `${paperBillingField.emptyFields.join(
          ", ",
        )} fields are required for Paper Billing`,
      );
    }

    if (!isReqDebitDetail.yes && !isReqDebitDetail.no) {
      return handleOpenSnackBar(
        "error",
        "Kindly select option for debit details",
      );
    }

    // if (isReqDebitDetail.yes) {
    //   const debitDetailField = areAllKeysFilled(debitDetails);

    //   if (!debitDetailField.allFilled) {
    //     return handleOpenSnackBar(
    //       "error",
    //       `${debitDetailField.emptyFields.join(
    //         ", ",
    //       )} fields are required for Debit Details`,
    //     );
    //   }

    //   if (!/^\d{6}$/.test(debitDetails?.shortCode?.trim())) {
    //     return handleOpenSnackBar("error", "The sort code must be 6 digits.");
    //   }
    //   if (!/^\d{7,8}$/.test(debitDetails?.accountNumber?.trim())) {
    //     return handleOpenSnackBar(
    //       "error",
    //       "Account number must be 7 or 8 digits only.",
    //     );
    //   }
    //   if (!isBankDetailsVerified) {
    //     return handleOpenSnackBar("error", "Debit details is not verified");
    //   }
    // }

    if (
      !validateOtherProductFields(otherProducts, otherProducts.selectedProducts)
    ) {
      return;
    }

    const selectedOtherProduct = otherProducts.selectedProducts.map(
      (productType) => {
        let productData = {};

        if (productType === "Energy") {
          const energyData = {};
          if (otherProducts.energy.electricity.isSelected) {
            energyData.electricity = otherProducts.energy.electricity;
          }
          if (otherProducts.energy.gas.isSelected) {
            energyData.gas = otherProducts.energy.gas;
          }
          productData = {
            productType,
            data: energyData,
          };
        } else if (productType === "Telecoms") {
          const telecomsData = {};
          if (otherProducts.telecoms.business.isSelected) {
            telecomsData.business = otherProducts.telecoms.business;
          }
          if (otherProducts.telecoms.residential.isSelected) {
            telecomsData.residential = otherProducts.telecoms.residential;
          }
          productData = {
            productType,
            data: telecomsData,
          };
        } else if (productType === "Card Processing") {
          productData = {
            productType,
            data: otherProducts.cardProcessing,
          };
        } else if (productType === "Mobile") {
          productData = {
            productType,
            data: otherProducts.mobile,
          };
        }

        return productData;
      },
    );

    if (phoneValidation?.IsValid === "No") {
      return handleOpenSnackBar("error", "Mobile Number is not verified");
    }

    if (
      totalGrossProfit <= 0 &&
      !adminDetails?.canPreview

      // !isAdmin &&
      // contractDetails?.createdBy === "Sales Agent"
    ) {
      return handleOpenSnackBar(
        "error",
        "Gross profit can not be negation or Zero",
      );
    }

    let payload = {
      accountNo,
      note,
      generalInfo,
      isBillingEmailSame,
      contractLength: selectedContractLength(contractLength),
      cliData,
      downloadSpeed,
      uploadSpeed,
      routerValue,
      cordedPhone,
      cordedlessPhone,
      equipments,
      paperBillingPrice,
      eBillingAddress,
      isDebitDetails: isReqDebitDetail.yes,
      debitDetails,
      totalRevenue,
      totalOneOfCost,
      totalGrossProfit: totalGrossProfit.toFixed(2),
      otherProduct: selectedOtherProduct,
      contractEndDate,
      followUpDate,
      isUpfrontPaymentCollected,
      isBankDetailsVerified,
      phoneDetail: phoneValidation,
      ...(discountDetails && { discountDetails, discount }),
      ...(isAdmin && { contractSignedAt: signedDate || null }),

      ...(logArray?.length > 0 && { logs: [...logArray] }),
      // contractNote: allNotes,
    };

    if (type === "save") {
      try {
        setIsLoading(true);
        const response = await updateContract(contractDetails?._id, payload);
        if (response?.data?.status === "success") {
          navigate("/all-prospects");
          // fetchContractsDetails(location?.state?.data?._id);
          dispatch(setPhoneValidation(null));
          dispatch(setSignedDate(null));
          handleResetData(true);
        } else {
          handleOpenSnackBar("error", response?.data?.message);
        }
      } catch (error) {
        handleOpenSnackBar("error", error?.message);
      } finally {
        setIsLoading(false);
      }
    } else {
      navigate("/preview-contract", {
        state: { type: "edit", id: contractDetails?._id },
      });
    }
  };

  useEffect(() => {
    const handleBeforeUnload = (event) => {
      event.preventDefault();
      event.returnValue =
        "Are you sure you want to reload? All your data will be lost!";
    };

    window.addEventListener("beforeunload", handleBeforeUnload);

    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, []);

  // useEffect(() => {
  //   window.scrollTo({
  //     top: 0,
  //     behavior: "smooth",
  //   });
  // }, [contractLength]);

  const handleDownloadContract = async (envelopeId) => {
    if (!envelopeId) return;

    const token = getAccessToken();

    try {
      setIsLoading(true);
      const response = await axios.get(
        `${baseUrl}contract/dowload/${envelopeId}`,
        {
          headers: {
            ...(token && {
              Authorization: `Bearer ${token}`,
            }),
          },
          responseType: "blob",
        },
      );

      const blob = new Blob([response.data], { type: "application/pdf" });
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = `docusign_contract_${envelopeId}.pdf`;
      document.body.appendChild(a);
      a.click();

      document.body.removeChild(a);
      window.URL.revokeObjectURL(url);
    } catch (error) {
      handleOpenSnackBar("error", "Error downloading Pdf");
    } finally {
      setIsLoading(false);
    }
  };

  const handleEditContract = (row) => {
    navigate("/edit-lead", { state: { data: row } });
    setSendType({
      type: "edit",
      id: row._id,
    });
  };

  const renderLinkedContracTable = useMemo(() => {
    return (
      <DynamicTable
        tableData={linkedContract}
        displayRows={displayRows}
        tableHeader={tableHeader}
        showEdit
        handleEdit={handleEditContract}
      />
    );
  }, [linkedContract]);

  return (
    <AppHeader>
      <AppLoader isVisible={isLoading} />

      <DuplicateCountDialog ref={openDublicateDialogRef} />
      <UpdateAgentDialog ref={openUpdateAgentDialogRef} />

      {/* Download Action */}

      <Stack
        direction={"row"}
        mt={2}
        gap={2}
        alignItems={"center"}
        justifyContent={"space-between"}
        flexWrap={"wrap"}
      >
        <Chip
          sx={{
            backgroundColor: "primary.main",
            color: "secondary.light",
            fontSize: "1rem",
            borderRadius: "8px ",
          }}
          label={`Sale Status : ${contractDetails?.saleStatus || ""}`}
        />

        <Stack
          direction={"row"}
          mt={2}
          gap={2}
          justifyContent={"flex-end"}
          flexWrap={"wrap"}
        >
          {/* <GenerateDuplicateContractButton
            contractData={contractDetails}
            setIsLoading={setIsLoading}
          /> */}

          {userData?.designation === "Admin" &&
            contractDetails?.status === "envelope-completed" &&
            contractDetails?.linkedContract === null && (
              <GlobalButton
                variant={"custom_gradient"}
                title={"Update Agent"}
                disabled={userData?.designation !== "Admin"}
                handleClickBtn={() =>
                  openUpdateAgentDialogRef.current.openDialog({
                    prospectId: contractDetails?._id,
                    agentId: contractDetails?.agentId,
                    getData: fetchContractsDetails,
                  })
                }
                style={{
                  width: "auto",
                  height: 35,
                  borderRadius: "8px",
                }}
              />
            )}
          {userData?.designation === "Sales Agent" && (
            <GlobalButton
              variant={"custom_gradient"}
              title={"Generate Duplicate Prospects"}
              disabled={userData?.designation === "Admin" ? true : false}
              handleClickBtn={() =>
                openDublicateDialogRef.current.openDialog({
                  data: {
                    ...contractDetails.generalInfo,
                    agentId: contractDetails?.agentId,
                    contractId: contractDetails?._id,
                  },
                })
              }
              style={{
                width: "auto",
                height: 35,
                borderRadius: "8px",
              }}
            />
          )}
          {contractDetails?.envelopId && (
            <GlobalButton
              variant={"custom_gradient"}
              title={"Download Docusign Contract"}
              handleClickBtn={() =>
                handleDownloadContract(location.state?.data?.envelopId)
              }
              style={{
                width: "auto",
                height: 35,
                borderRadius: "8px",
              }}
            />
          )}

          <PDFDownloadLink
            document={
              <ContractSummaryPDF
                generalInfo={generalInfo}
                cliData={cliData}
                downloadSpeed={downloadSpeed}
                uploadSpeed={uploadSpeed}
                routerValue={routerValue}
                cordedPhone={cordedPhone}
                cordedlessPhone={cordedlessPhone}
                equipments={equipments}
                isReqDebitDetail={isReqDebitDetail}
                paperBillingPrice={paperBillingPrice}
                calculateOneOfCost={calculateOneOfCost}
                calculateTotalRevenue={calculateTotalRevenue}
                contractLength={contractLength}
                discountDetails={contractDetails?.discountDetails}
              />
            }
            fileName={`pre_contract_summary_pdf`}
          >
            {({ blob, url, loading, error }) => (
              <GlobalButton
                variant={"custom_gradient"}
                disabled={loading}
                title={
                  loading
                    ? "Loading document..."
                    : "Download Pre-Contract summary"
                }
                style={{
                  width: "auto",
                  height: 35,
                  borderRadius: "8px",
                }}
              />
            )}
          </PDFDownloadLink>
        </Stack>
      </Stack>

      {/* General Information */}

      <GeneralConnections />

      {/* Contract length */}
      <ContractLength />

      {selectedContractLength(contractLength) !== undefined && (
        <>
          {/* cli */}
          <Cli />

          {/* Dowload */}
          {/* <Download /> */}
          {isDownloadSpeed && <Download />}

          {/* upload */}
          {/* <Upload /> */}
          {isUploadSpeed && <Upload />}

          {/* Routers */}
          <Routers />

          {/* Corded Phone*/}
          {/* {!legacySelectedCheck() && <CordedValues />} */}

          <CordedPhone />

          {/* Cordless Phone */}

          <CordedlessPhone />

          {/* Other Equipments */}
          <Equipments />

          {/* Discount */}
          <Discount />

          {/* Platform upgrade charge not using now because every box has own upgradecharge*/}

          {/* <PlatformUpgradeCharge /> */}

          {/*  Paper billing charges */}
          <PaperBillingCharges />

          {/* Same connections */}
          {generalInfo.eBilling && generalInfo.eBilling === "No" && (
            <SameConnections />
          )}

          {/* Debit details */}
          <DebitDetails type={"edit"} />

          {/* Other Products */}
          <OtherProducts />

          {/* Note  */}
          <Note
            contractDetails={contractDetails}
            type={"edit"}
            fetchDetail={() =>
              fetchContractsDetails(location?.state?.data?._id)
            }
          />

          {isAdmin && <SignedDate />}

          {/* Linked Contract */}

          {linkedContract?.length > 0 && (
            <Box mt={2}>
              <Typography variant="h6" color={"text.charcoalGrey"}>
                Linked Contracts
              </Typography>
              <Box mb={3}></Box>
              {renderLinkedContracTable}
            </Box>
          )}

          {/* Logs */}

          {contractDetails?.logs?.length > 0 && (
            <Logs allData={contractDetails?.logs} />
          )}

          {/* Button */}

          <Stack
            my={5}
            mb={{ xs: 14, md: 8 }}
            direction={{ md: "row" }}
            alignItems={"flex-end"}
            justifyContent={"flex-end"}
            gap={1}
          >
            {location?.pathname === "/edit-lead" && (
              <>
                <GlobalButton
                  variant={"custom_gradient"}
                  title={"Save Contract"}
                  handleClickBtn={() => handleUpdateOrPreviewContract("save")}
                  style={{
                    display: "flex",
                    width: { xs: "100%", sm: 260 },
                    fontSize: "1rem",
                    alignSelf: "flex-end",
                    mt: 0,
                  }}
                />
                {/* {!isAdmin && ( */}
                <GlobalButton
                  variant={"custom_gradient"}
                  title={"Preview Contract"}
                  handleClickBtn={() =>
                    handleUpdateOrPreviewContract("preview")
                  }
                  style={{
                    width: { xs: "100%", sm: 260 },
                    fontSize: "1rem",
                    borderRadius: "100px",
                  }}
                />
                {/* )} */}
              </>
            )}
          </Stack>

          {/* fixed bottom tab to show profits */}
          <Stack
            bgcolor={"primary.main"}
            px={2}
            py={1}
            position={"fixed"}
            bottom={0}
            left={0}
            right={0}
            direction={{ xs: "column", sm: "row" }}
            justifyContent={"flex-end"}
            alignItems={{ xs: "flex-start", sm: "center" }}
            spacing={{ sm: 2 }}
          >
            <Typography
              fontSize={{ xs: "1.12rem", sm: "1.225rem" }}
              color={"secondary.light"}
            >
              Revenue: £{totalRevenue}
            </Typography>
            <Typography
              fontSize={{ xs: "1.12rem", sm: "1.225rem" }}
              color={"secondary.light"}
            >
              One-off Cost: £{totalOneOfCost}
            </Typography>
            <Typography
              fontSize={{ xs: "1.12rem", sm: "1.225rem" }}
              color={"secondary.light"}
            >
              Gross Profit: £{totalGrossProfit.toFixed(2)}
            </Typography>
          </Stack>
        </>
      )}
    </AppHeader>
  );
};

export default EditConnectionsPage;
